define('lq/events/actions/mollieCreateCustomer',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    function MollieCreateCustomer(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(MollieCreateCustomer, EventAction);

    MollieCreateCustomer.typeName = 'MollieCreateCustomer';

    MollieCreateCustomer.prototype.getBatchType = function () {
        return EventAction.COMMAND_BATCH;
    };

    MollieCreateCustomer.prototype.createEventActionRequest = function () {
        return {
            eventActionType: "CreateMollieCustomer",
            commandId: this.eventData.command
        };
    };

    return MollieCreateCustomer;
});
